
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(98),
  playerId: Number.withConstraint(x => x >= 1),
  timestamp: Number.withConstraint(x => x >= 1),
  facebook_connection_state: String.withConstraint(x => x.length <= 20),
  game_level: Number.withConstraint(x => x >= 0),
}).And(Partial({
  user_external_id: String.withConstraint(x => x.length <= 100),
  facebook_business_token: String.withConstraint(x => x.length <= 100),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(98),
  playerId: Number.withConstraint(x => x >= 1),
  timestamp: Number.withConstraint(x => x >= 1),
  facebook_connection_state: String.withConstraint(x => x.length <= 20),
  game_level: Number.withConstraint(x => x >= 0),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 1 && x <= 200),
  instanceId: Number.withConstraint(x => x >= 1 && x <= 1000),
}).And(Partial({
  user_external_id: String.withConstraint(x => x.length <= 100),
  facebook_business_token: String.withConstraint(x => x.length <= 100),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 98;
  